import React from "react";
import { LeftOutlined } from "@ant-design/icons";
import DemoRequestComponent from "../../components/forms/DemoRequest";

export default function BookingConfirmation({ selectedDate, selectedTime, goBack, dateTime, getFormattedDate, onSuccess }) {
  return (
    <div>
      <h3 className="text-center text-lg font-medium mb-2">Confirm Booking</h3>
      <div className="text-sm text-gray-400 mb-[16px] text-center flex justify-between items-center">
        <button onClick={goBack} className="p-0 text-white font-bold text-xl">
          <LeftOutlined />
        </button>
        <div>{`${getFormattedDate(selectedDate)} | ${selectedTime} - 30 minutes`}</div>
        <div></div>
      </div>
      <DemoRequestComponent date_time={dateTime} onSuccess={onSuccess} />
    </div>
  );
}
